/* globals angular, ga */

(function () {
  var module = angular.module('ace.errorService', []);

  module.config([
    '$provide',
    function ($provide) {
      $provide.decorator('$exceptionHandler', [
        '$delegate',
        function ($delegate) {
          return function (exception, cause) {
            $delegate(exception, cause);

            if (typeof ga === 'undefined') {
              return;
            }

            ga(
              'send',
              'event',
              'AngularJS error',
              exception.message,
              exception.stack,
              0,
              true
            );
          };
        },
      ]);
    },
  ]);
})();
